module.exports = __webpack_public_path__ + "img/403.fa923077.svg";